import {Component, OnInit, HostListener} from '@angular/core';
import {trigger, state, style, animate, transition} from '@angular/animations';

import {NavBarService} from '../../../services/nav-bar/nav-bar.service';
import {LanguageService} from '../../../services/languages/language.service';
import {TranslateService} from '../../pipes/translate/translate.service';
import {SIZE_HIDE_MENU} from '../../constants';
import {from} from 'rxjs';

@Component({
  selector: 'app-side-nav-bar',
  templateUrl: './side-nav-bar.component.html',
  styleUrls: ['./side-nav-bar.component.scss'],
  animations: [
    trigger('openClose', [
      state('close', style({
        height: '0',
        opacity: 0,
        margin: '0 0 0 0'
      })),
      state('open', style({
        opacity: 1,
        height: '22px',
        margin: '10px 0 0 0'
      })),
      transition('* => open', [animate('0.3s')]),
      transition('* => close', [animate('0.4s 0.4s')]),
    ]),
    trigger('openCloseHowToSell', [
      state('close', style({
        height: 0,
        opacity: 0,
        margin: '0 0 0 0',
        visibility: 'hidden'
      })),
      state('open', style({
        opacity: 1,
        height: '10px',
        margin: '10px 0 6vh',
        visibility: 'visible'
      })),
      transition('close => open', [animate('0.3s')]),
      transition('open => close', [animate('0.4s 0.4s')]),
    ]),
    trigger('showHideMenu', [
      state('closeMenu', style({
        transform: 'translateX(-100%)'
      })),
      state('openMenu', style({
        transform: 'translateX(0%)'
      })),
      transition('* => closeMenu', [animate('0.3s')]),
      transition('* => openMenu', [animate('0.3s')]),
    ])
  ]
})
export class SideNavBarComponent implements OnInit {

  selectedMainMenu: string;
  fbLikeUsPageUrl = 'https://www.facebook.com/%D0%9B%D0%9E%D0%93%D0%9E%D0%A1-%D0%BD%D0%B5%D0%B4%D0%B2%D0%B8%D0%B6%D0%B8%D0%BC%D0%B8-%D0%B8%D0%BC%D0%BE%D1%82%D0%B8-1454180924811512/';
  fbLogo = '/assets/images/fb_logo.jpg';
  currentLanguageKey = 'bg';
  openEstates = false;
  openHelpful = false;
  openAboutUs = false;
  showHideMenu = false;

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (window.innerWidth >= SIZE_HIDE_MENU) {
      this.showHideMenu = true;
    } else {
      this.showHideMenu = false;
    }
  }

  constructor(
    public navService: NavBarService,
    public ls: LanguageService,
    private translateService: TranslateService
  ) {
  }

  ngOnInit() {
    this.navService.homeClicked();
    this.ls.setLanguage(this.currentLanguageKey);
    this.onResize(true);
  }

  setLang(lang: string) {
    this.ls.setLanguage(lang);
    this.translateService.use(lang);
    this.currentLanguageKey = lang;
  }

  menuClicked() {
    this.showHideMenu = !this.showHideMenu;
  }

  homeClicked() {
    this.openEstates = false;
    this.openHelpful = false;
    this.openAboutUs = false;
    this.onResize(true);
    this.navService.homeClicked();
  }

  estatesClicked(subMenu: string) {
    this.openEstates = true;
    this.openHelpful = false;
    this.openAboutUs = false;
    this.onResize(true);
    if (subMenu === 'estates') {
      this.navService.estatesClicked();
    } else if (subMenu === 'sales') {
      this.navService.salesClicked();
    } else if (subMenu === 'rents') {
      this.navService.rentsClicked();
    } else if (subMenu === 'createOffer') {
      this.navService.createOfferClicked();
    } else if (subMenu === 'subscription') {
      this.navService.subscriptionClicked();
    }
  }

  newsClicked() {
    this.openEstates = false;
    this.openHelpful = false;
    this.openAboutUs = false;
    this.onResize(true);
    this.navService.newsClicked();
  }

  servicesClicked() {
    this.openEstates = false;
    this.openHelpful = false;
    this.openAboutUs = false;
    this.onResize(true);
    this.navService.servicesClicked();
  }

  helpClicked(subMenu: string) {
    this.openEstates = false;
    this.openHelpful = true;
    this.openAboutUs = false;
    this.onResize(true);
    if (subMenu === 'helpful') {
      this.navService.helpClicked();
    } else if (subMenu === 'regionAndCountry') {
      this.navService.countryAndRegionClicked();
    } else if (subMenu === 'notaryCalculator') {
      this.navService.notaryCalculatorClicked();
    } else if (subMenu === 'howToSell') {
      this.navService.howToSellClicked();
    } else if (subMenu === 'policy') {
      this.navService.policyClicked();
    }
  }

  aboutClicked(subMenu: string) {
    this.openEstates = false;
    this.openHelpful = false;
    this.openAboutUs = true;
    this.onResize(true);
    if (subMenu === 'about') {
      this.navService.aboutClicked();
    } else if (subMenu === 'history') {
      this.navService.historyClicked();
    } else if (subMenu === 'principles') {
      this.navService.principlesClicked();
    } else if (subMenu === 'team') {
      this.navService.teamClicked();
    }

  }

  contactsClicked() {
    this.openEstates = false;
    this.openHelpful = false;
    this.openAboutUs = false;
    this.onResize(true);
    this.navService.contactsClicked();
  }

  clickFbLikeUsPage(): void {
    window.open(this.fbLikeUsPageUrl);
  }
}
